// Firestore-Transport.
//
// Ein Read für die Seite: `pipr/{bank}` trägt Anker, Meeting-Liste,
// Terminstruktur und das laufende Jahr. Abgeschlossene Jahre stehen in
// `pipr/{bank}/years/{year}` und werden hier parallel dazugeholt — welche es
// gibt, sagt `head.years`, der Client rät nie eine Dokument-ID.
//
// `head.years` enthält auch das laufende Jahr, das aber im Head steckt und
// nicht in der Subcollection. Es muss vor den Reads herausgefiltert werden.
//
// Die Firestore-Instanz kommt aus src/firebase.ts, derselben, mit der das
// Newsletter-Formular schreibt.

import { doc, getDoc } from "firebase/firestore";

import { db } from "../../../firebase";
import { fromFirestore } from "./wire";
import type { WireHead, WireYear } from "./wire";
import { SUPPORTED_SCHEMA } from "../types";
import type { Bank, PiprBundle } from "../types";

const COL_ROOT = "pipr";
const SUB_YEARS = "years";

/**
 * @param withHistory false lädt nur den Head — ein Read, laufendes Jahr,
 *                    ausreichend für die Zoomstufen bis 1 Jahr.
 */
export async function loadFirestore(bank: Bank, withHistory = true): Promise<PiprBundle> {
    const snap = await getDoc(doc(db, COL_ROOT, bank));
    if (!snap.exists()) throw new Error("network");

    const head = snap.data() as WireHead;
    if (head.schema_version !== SUPPORTED_SCHEMA) throw new Error("schema");
    if (head.bank !== bank) throw new Error("schema");

    let closed: WireYear[] = [];
    if (withHistory) {
        const older = (head.years || []).filter((y) => y !== head.current_year.year);
        const docs = await Promise.all(
            older.map((y) => getDoc(doc(db, COL_ROOT, bank, SUB_YEARS, String(y)))),
        );
        // Ein fehlendes Jahr ist kein Fehler: der Head kann eine Sekunde vor
        // seinen Jahresdokumenten liegen. Lieber ein kürzerer Chart als keiner.
        closed = docs.filter((d) => d.exists()).map((d) => d.data() as WireYear);
    }

    return fromFirestore(head, closed);
}